export default __webpack_public_path__ + "static/media/TimeCalendar.bf92c54b.svg";